import "react-toastify/dist/ReactToastify.css";
import "./style/style.css";
import "./plugin";

import React from "react";
import ReactDOM from "react-dom/client";
// import { registerSW } from "virtual:pwa-register";
import App from "./App.tsx";
import { Provider } from "react-redux";
import store from "./store";
import ApolloCustomProvider from "./shared/providers/apollo-custom.provider.tsx";
import { CookiesProvider } from "react-cookie";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <CookiesProvider>
      <Provider store={store}>
        <ApolloCustomProvider>
          <App />
        </ApolloCustomProvider>
      </Provider>
    </CookiesProvider>
  </React.StrictMode>,
);

// if ("serviceWorker" in navigator) {
//     // && !/localhost/.test(window.location)) {
//     registerSW();
// }
